import React from 'react';
import { CallbackComponent } from 'redux-oidc';
import { RouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import getUserManager from '../../security/oidcUserManager';
import { LoadingPage } from '../../pages';

export const CallbackPage = ({
  history,
}: RouteComponentProps): React.ReactElement<RouteComponentProps> => (
  <CallbackComponent
    userManager={getUserManager()}
    successCallback={() => {
      history.push({
        pathname: '/',
      });
    }}
    errorCallback={error => {
      console.log('Error OIDC callback');
      history.push({
        pathname: '/',
      });
      console.error(error);
    }}
  >
    <LoadingPage />
  </CallbackComponent>
);

export default withRouter(CallbackPage);
